import { StyleSheet } from 'react-native';

import {
  ActionTile,
  IconAdd,
  IconRedeem,
  IconWalletOutline,
  Text,
  XStack,
  YStack,
  tokens,
} from '@fhs/ui';

import { BalanceIcon } from '../../components/balance-icon';
import { GiftCardImage } from '../../components/gift-card-image/gift-card-image';
import { GiftCardNumber } from '../../components/gift-card-number';
import { useGiftCardContext } from '../../state/gift-card';

import { GiftCardsProps } from './types';

export function GiftCardsDesktop(props: GiftCardsProps) {
  const { formattedBalance, hasGiftCard } = useGiftCardContext();

  return (
    <XStack style={styles.container}>
      {hasGiftCard ? (
        <>
          <YStack style={styles.leftWrapper}>
            <GiftCardImage />
            <GiftCardNumber
              lastDigits={props.lastDigits}
              onPress={props.onPressShowCardNumber}
              isRedacted={props.isCardNumberRedacted}
              isLoading={props.isCardNumberLoading}
              cardNumber={props.cardNumber}
              pin={props.pin}
            />
          </YStack>
          <YStack style={styles.rightWrapper}>
            <ActionTile
              Icon={<IconAdd size={24} color={tokens.colors.$houseRedDarken} />}
              title="Add Gift Card"
              subtitle="Do you have an existing gift card?"
              onPress={props.onAddGiftCardPress}
            />
            <ActionTile
              Icon={<IconWalletOutline size={24} color={tokens.colors.$houseRedDarken} />}
              title="Check Balance"
              subtitle="Check the balance of your physical gift card"
              onPress={props.onCheckBalancePress}
            />
            <ActionTile
              Icon={<BalanceIcon animate={false} />}
              title={formattedBalance}
              subtitle="Card Balance"
              indicatorText="See History"
              onPress={props.onSeeHistoryPress}
              iconCircleStyle={{ backgroundColor: tokens.colors.$blackOpacity04 }}
              isLoading={props.isDigitalBalanceLoading}
            />
          </YStack>
        </>
      ) : (
        <XStack style={styles.emptyStateContainer}>
          <YStack style={styles.emptyStateCard}>
            <IconRedeem size={80} color={tokens.colors.$blackOpacity10} />
            <Text weight="semibold" style={styles.emptyStateTextTitle}>
              Bring Your Gift Card to the App
            </Text>
            <Text style={styles.emptyStateTextSubtitle}>
              Got a physical gift card? Add it here to turn it digital. Keep it all in one place.
            </Text>
          </YStack>
          <YStack style={styles.rightWrapper}>
            <ActionTile
              Icon={<IconAdd size={24} color={tokens.colors.$houseRedDarken} />}
              title="Add Gift Card"
              subtitle="Do you have an existing gift card?"
              onPress={props.onAddGiftCardPress}
            />
            <ActionTile
              Icon={<IconWalletOutline size={24} color={tokens.colors.$houseRedDarken} />}
              title="Check Balance"
              subtitle="Check the balance of your physical gift card"
              onPress={props.onCheckBalancePress}
            />
          </YStack>
        </XStack>
      )}
    </XStack>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: 16,
    gap: 16,
    flex: 1,
    backgroundColor: tokens.colors.$white,
  },
  leftWrapper: {
    flex: 1,
  },
  rightWrapper: {
    flex: 1,
    gap: 16,
  },
  emptyStateContainer: {
    flex: 1,
    gap: 16,
    maxHeight: 220,
  },
  emptyStateCard: {
    borderRadius: 8,
    borderWidth: 1,
    borderColor: tokens.colors.$blackOpacity10,
    paddingVertical: 16,
    paddingHorizontal: 56,
    alignItems: 'center',
  },
  emptyStateTextTitle: {
    fontSize: 18,
    marginTop: 16,
    marginBottom: 8,
    lineHeight: 25.2,
  },
  emptyStateTextSubtitle: {
    lineHeight: 19.6,
    textAlign: 'center',
  },
});
